import { createFileRoute, useCanGoBack } from '@tanstack/react-router'

import { Authentication } from '@/rbac'
import { RouteProfileProvider } from '@/routes/arc/profile/-context/route-profile-provider.tsx'
import Profile from '@/routes/arc/profile/-Profile.tsx'
import { profileIdentitySchema } from '@/routes/arc/profile/-types/ProfileIdentity.ts'

export const Route = createFileRoute('/arc/profile')({
  component: ProfilePage,
  validateSearch: profileIdentitySchema,
})

function ProfilePage() {
  const callGoback = useCanGoBack()

  return (
    <RouteProfileProvider>
      <div className={'fit-col p-2.5'}>
        <Authentication require={['arc:profile']} failMode={'empty'}>
          <Profile key={'scheme-page'} hasBack={callGoback} showEdit={true} showSwitch={false} />
        </Authentication>
      </div>
    </RouteProfileProvider>
  )
}
